import { REDUX_ACTION } from './constants';

// NOTE: This is a set of "common" actions. Our other libraries (@socialive/*) may need to utilize these actions,
// but the implementation for each of these selectors may vary between applications. Each application will need to
// "configure" their individual implementations via the `setReduxAction` function.

const delegatedAction = (type) => {
  const action = (...args) => action.delegate(...args);
  // eslint-disable-next-line no-console
  action.delegate = () => console.warn(`Redux Action not implemented: ${type}`);
  return action;
};

const delegates = Object.fromEntries(Object.values(REDUX_ACTION).map((key) => [key, delegatedAction(key)]));

export const {
  brokerEmit,
  brokerEmitSilent,
  completeMultipartUpload,
  fetchQuery,
  initMultipartUpload,
  multipartUpload,
  publish,
  refetchQueries,
  removeQueries,
  subscribe,
  toggleLocalTrackMuted,
  unpublish,
  uploadChunk,
} = delegates;

export const setReduxAction = (key, action) => {
  const delegate = delegates[key];

  if (!delegate) {
    throw new Error(`Invalid redux action: ${key}`);
  }

  delegate.delegate = action;
};
